const About = () => {
  return (
    <section id="about" className="py-28 px-4 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-white font-semibold text-sm uppercase tracking-wider bg-emerald-600 px-5 py-2 rounded-full shadow-md">About Choix</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Building Brighter Futures Together
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            A private non-profit organization dedicated to enhancing quality of life through personalized support and comprehensive vocational training
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="/images/601768e49d718d15930053c762604456.jpg" 
                alt="Choix Vocational Services Team" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-teal-600 to-teal-700 text-white p-6 rounded-2xl shadow-2xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-award-line text-3xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold">13+</div>
                  <div className="text-sm text-white/90">Years Strong</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900 leading-tight">
              Empowering Individuals with Intellectual & Developmental Disabilities
            </h3>
            
            <p className="text-gray-600 text-lg leading-relaxed">
              Since 2012, Choix Vocational Services has been a trusted partner in the lives of individuals and families throughout Los Angeles County. We work closely with regional centers to deliver exceptional day programs and vocational training.
            </p>

            <p className="text-gray-600 leading-relaxed">
              Our approach is rooted in respect, dignity, and individualized care. Every person we serve receives a customized plan designed to help them achieve their personal goals and lead fulfilling, independent lives.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 pt-6">
              <div className="bg-gray-50 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                  <i className="ri-user-heart-line text-teal-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Person-Centered Care</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Individualized plans tailored to unique needs and aspirations</p>
              </div>

              <div className="bg-gray-50 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                  <i className="ri-team-line text-teal-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Expert Team</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Certified professionals committed to excellence</p>
              </div>
            </div>
          </div>
        </div>

        {/* Partner Regional Centers */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-12 shadow-lg border border-gray-200">
          <div className="text-center mb-10">
            <h3 className="text-3xl font-bold text-gray-900 mb-3">Our Regional Center Partners</h3>
            <p className="text-gray-600 text-lg">Collaborating with leading regional centers across Los Angeles County</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl mx-auto mb-5 group-hover:scale-110 transition-transform">
                <i className="ri-building-line text-teal-600 text-4xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">Eastern LA Regional Center</h4>
              <p className="text-gray-600 text-sm">Serving East Los Angeles communities</p>
            </div>

            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl mx-auto mb-5 group-hover:scale-110 transition-transform">
                <i className="ri-building-line text-teal-600 text-4xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">Frank D. Lanterman Regional Center</h4>
              <p className="text-gray-600 text-sm">Supporting San Gabriel Valley residents</p>
            </div>

            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl mx-auto mb-5 group-hover:scale-110 transition-transform">
                <i className="ri-building-line text-teal-600 text-4xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">San Gabriel Pomona Regional Center</h4>
              <p className="text-gray-600 text-sm">Providing services to Pomona area</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
